<script setup lang="ts">
import { computed } from 'vue';
import {
    quizPerformanceToGradeString,
    QuizStatus,
    type FinalQuiz,
    type StagePerformance,
    type EocPerformance,
    type PracticePerformance,
    type OptionalQuiz,
    type QuizPerformance,
} from '@/types/Performance';

const props = defineProps<{
    quizTest: FinalQuiz|OptionalQuiz|StagePerformance|EocPerformance|PracticePerformance|string;
}>();

const score = computed(() => quizPerformanceToGradeString(props.quizTest));

const quizNotStarted = computed(() => (props.quizTest as QuizPerformance).status === QuizStatus.notStarted);
</script>

<template>
    <q-td>
        <div v-if="(typeof quizTest === 'string')">
            {{ quizTest }}
        </div>
        <div v-else>
            <span>{{ score }}</span>
            <span
                v-if="!quizNotStarted"
                class="review-button q-pl-md"
            >
                <router-link
                    v-slot="{ href }"
                    class="text-fsum-blue"
                    :to="{
                        name: 'testReview',
                        params: {
                            schoolSlug: $route.params.schoolSlug,
                            courseSlug: $route.params.courseSlug,
                            cusId: $route.params.cusId,
                            testId: quizTest.testSessionId,
                            testType: quizTest.type,
                        }
                    }"
                    custom
                >
                    <q-btn
                        label="Review"
                        :ripple="false"
                        class="anchor-button text-body2"
                        color="fsum-med-blue"
                        icon-right="sym_o_arrow_forward_ios"
                        no-caps
                        dense
                        flat
                        :to="href"
                    />
                </router-link>
            </span>
        </div>
    </q-td>
</template>
